/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithBatchItemRequestBuilder, WithBatchItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/orders/batches
 */
export interface BatchesRequestBuilder extends BaseRequestBuilder<BatchesRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.orders.batches.item collection
     * @param batchId The batch id, as place-lines and each of its orders report it.
     * @returns {WithBatchItemRequestBuilder}
     */
     byBatchId(batchId: string) : WithBatchItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const BatchesRequestBuilderUriTemplate = "{+baseurl}/api/orders/batches";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const BatchesRequestBuilderNavigationMetadata: Record<Exclude<keyof BatchesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byBatchId: {
        requestsMetadata: WithBatchItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["batchId"],
    },
};
/* tslint:enable */
/* eslint-enable */
